import { useEffect, useReducer } from 'react'
import { useTimeStore } from '@/store/common/useTimeStore'

const MINUTE_MS = 60 * 1000

const getCurrentTime = () => {
  return useTimeStore.getState().getBaseTime()
}

const getNextMinuteDelay = (currentTime) => {
  const elapsed = currentTime.getSeconds() * 1000 + currentTime.getMilliseconds()

  return MINUTE_MS - elapsed
}

export const useMinuteTicker = ({ enabled = true } = {}) => {
  const serverTime = useTimeStore((state) => state.serverTime)

  const [, forceMinuteRender] = useReducer((count) => count + 1, 0)

  useEffect(() => {
    if (!enabled) return

    let timeoutId

    const scheduleNextMinute = () => {
      const now = getCurrentTime()
      const delay = getNextMinuteDelay(now)

      timeoutId = window.setTimeout(() => {
        forceMinuteRender()
        scheduleNextMinute()
      }, delay)
    }

    const resync = () => {
      window.clearTimeout(timeoutId)
      forceMinuteRender()
      scheduleNextMinute()
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        resync()
      }
    }

    scheduleNextMinute()

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.clearTimeout(timeoutId)

      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [enabled, serverTime])

  return getCurrentTime()
}
